import { U21BetaFeatureLabel, U21Spacer } from 'app/shared/u21-ui/components';
import { useSelector } from 'react-redux';
import { selectConsortiumAlertsSummaryEnabled } from 'app/shared/featureFlags/selectors';

export const ConsortiumHitsTabLabel = () => {
  const consortiumAlertsSummaryEnabled = useSelector(
    selectConsortiumAlertsSummaryEnabled,
  );
  if (!consortiumAlertsSummaryEnabled) {
    return 'Consortium Hits';
  }
  return (
    <U21Spacer horizontal useFlexGap>
      Consortium Hits
      <U21BetaFeatureLabel />
    </U21Spacer>
  );
};
